<div
  class="ci-wrapper"
  [class.ci-wrapper--focused]="isFocused"
  [class.ci-wrapper--disabled]="isDisabled"
  [class.ci-wrapper--naked]="naked"
  [class.ci-wrapper--has-leading]="!!icon"
  [class.ci-wrapper--has-trailing]="!!trailingIcon"
>
  <!-- Leading icon -->
   @if (icon) {

  <span class="ci-icon ci-icon--leading">
    <i [class]="icon"></i>
  </span>
}

  <!-- Native input -->
  <input data-testid="auto-app-custom-input-input-1"
    #inputEl
    class="ci-input"
    [type]="type"
    [placeholder]="placeholder"
    [value]="value !== null && value !== undefined ? value : ''"
    [attr.disabled]="isDisabled ? true : null"
    [readOnly]="readonly"
    [attr.maxlength]="maxlength"
    [attr.min]="min"
    [attr.max]="max"
    (input)="onInput($event)"
    (change)="onChange($event)"
    (focus)="onFocus($event)"
    (blur)="onBlur($event)"
    autocomplete="off"
  />

  <!-- Trailing icon -->
   @if (trailingIcon) {
  <span class="ci-icon ci-icon--trailing">
    <i [class]="trailingIcon"></i>
  </span>
}
</div>
